import { useState } from "react";
import axiosInstance from "../../config/axiosConfig.js";
import { useParams, useNavigate } from "react-router-dom";
import "../../style/Authentification/Authentification.css";
import "../../style/EntryPages.css";
import { extractApiErrorMessage } from "../../utils/apiErrorMessage";

function Login() {
  const { personne } = useParams();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const isEleve = personne === "eleves";
  const titre = isEleve ? "Connexion eleve" : "Connexion encadrant-tuteur";
  const accentClass = isEleve ? "is-student" : "is-mentor";

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!email.trim()) {
      setErrorMessage("Renseignez votre email de connexion.");
      return;
    }

    if (!password) {
      setErrorMessage("Renseignez votre mot de passe.");
      return;
    }

    const data = {
      email: email,
      password: password,
    };

    axiosInstance
      .post(`/authentification/login/${personne}`, data)
      .then((response) => {
        const token = response.data.token;
        const userId = response.data.eleveId
          ? response.data.eleveId
          : response.data.profId;
        localStorage.setItem("token", token);
        localStorage.setItem("userId", userId);
        localStorage.setItem("personne", personne);
        navigate("/");
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage(
          extractApiErrorMessage(
            error,
            "Impossible de se connecter. Verifiez votre email et votre mot de passe."
          )
        );
      });

    setPassword("");
  };

  return (
    <div className="entry-page">
      <div className="entry-shell">
        <div className="entry-header">
          <span className={`entry-accent ${accentClass}`}>
            {isEleve ? "Espace eleve" : "Espace encadrant"}
          </span>
          <h1 className={`entry-title ${accentClass}`}>{titre}</h1>
          <p className="entry-subtitle">
            Connectez-vous pour retrouver votre espace personnel et acceder aux
            informations de votre stage.
          </p>
        </div>

        {errorMessage && <p className="entry-message is-error">{errorMessage}</p>}

        <div className="entry-card is-form contain-form-auth">
          <form onSubmit={handleSubmit} className="entry-form contain-auth">
            <div className="form-group">
              <label>Email de connexion</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={handleEmailChange}
                placeholder="Email de connexion"
              />
            </div>

            <div className="form-group">
              <label>Mot de passe</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={handlePasswordChange}
                placeholder="Mot de passe"
              />
            </div>

            <div className="entry-form-actions">
              <button className="btn" type="submit">
                Se connecter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
